import countryList from './countryList.json'

const getCountryCodeList = countryList.map(key => ({
  label: key.dial,
  id: key.dial
}))

export default getCountryCodeList
